import React from 'react';

const BannerLink = ({
  linkUrl,
  linkLabel,
  className = '',
  inline = false,
  onTrackClick,
}) => {
  if (!linkUrl?.trim()) return null;

  const handleClick = () => {
    if (onTrackClick) {
      try {
        onTrackClick();
      } catch {
        // El enlace debe abrirse aunque falle el tracking.
      }
    }
  };

  return (
    <>
      {inline ? ' ' : null}
      <a
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={handleClick}
      >
        {linkLabel?.trim() || 'Ver más'}
      </a>
    </>
  );
};

export default BannerLink;
